import { render } from "./CorporateDirectory.vue?vue&type=template&id=e63a620e&scoped=true"
import script from "./CorporateDirectory.vue?vue&type=script&lang=js"
export * from "./CorporateDirectory.vue?vue&type=script&lang=js"

import "./corporate-directory.scss?vue&type=style&index=0&id=e63a620e&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e63a620e"]])

export default __exports__